var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"material-Input-Price-View"},[_c('PageTitle',{attrs:{"imagem":"bottles.png","main":"Orçamento de Insumos","sub":""}}),_c('MaterialInputPriceView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }